import React from 'react';
import styled, { css } from 'styled-components';

const StyledIcon = styled.i`
  display:flex;
  align-items:center;
  width: ${(props) => props.width || '24px'};
  height: ${(props) => props.height || '24px'};
  background-size: contain;
  background-repeat: no-repeat;
 
  ${(props) => props.kind === 'ticket' && css`
    background-image: url('/Site/images/icons/order-details/ticket.svg');   
  `}

   ${(props) => props.kind === 'copy' && css`
    background-image: url('/Site/images/icons/order-details/copy.svg');   
  `}

  ${(props) => props.kind === 'ticket_purple' && css`
    background-image: url('/Site/images/icons/order-details/ticket_purple.svg');
    height: 23px; 
  `}

    ${(props) => props.kind === 'auth-needed' && css`
    background-image: url('/Site/images/icons/order-details/auth-needed.svg');   
    height: 23px;
  `}


  ${(props) => props.kind === 'tickets' && css`
    background-image: url('/Site/images/icons/order-details/tickets.svg');   
  `}

  ${(props) => props.kind === 'product' && css`
    background-image: url('/Site/images/icons/order-details/product.svg');
               
  `}

    ${(props) => props.kind === 'product-black' && css`
    background-image: url('/Site/images/icons/order-details/product-black.svg');
               
  `}

  ${(props) => props.kind === 'date' && css`
    background-image: url('/Site/images/icons/order-details/date.svg');    
  `}

    ${(props) => props.kind === 'location' && css`
    background-image: url('/Site/images/icons/order-details/location.svg');
    
  `}

     ${(props) => props.kind === 'rightArrow' && css`
    background-image: url('/Site/images/icons/order-details/right-arrow.svg');
   
  `}

     ${(props) => props.kind === 'print' && css`
    background-image: url('/Site/images/icons/order-details/print.svg');
   
  `}

       ${(props) => props.kind === 'print_purple' && css`
    background-image: url('/Site/images/icons/order-details/print_purple.svg');
    width: 16px;
    height: 16px;
   
  `}

  ${(props) => props.kind === 'print_purple-hover' && css`
    background-image: url('/Site/images/icons/order-details/print_purple-hover.svg');
    width: 16px;
    height: 16px;
   
  `}

    ${(props) => props.kind === 'cancel' && css`
    background-image: url('/Site/images/icons/order-details/cancel.svg');  
  `}

    ${(props) => props.kind === 'spinner' && css`
    background-image: url('/Site/images/icons/order-details/spinner.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    width: 1.5em;
    height: 1.5em;
    display: inline-block;

    animation: spin 1s linear infinite;
    transform-origin: center;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`}

    ${(props) => props.kind === 'loading_spinner' && css`
    background-image: url('/Site/images/icons/order-details/loading_spinner.png');
    width: 18px;
    height: 18px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;

    animation: spin 2s linear infinite;
    transform-origin: center;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`}
    ${(props) => props.kind === 'seat' && css`
    background-image: url('/Site/images/icons/order-details/seat.svg');  
  `}
  ${(props) => props.kind === 'change' && css`
    background-image: url('/Site/images/icons/order-details/change.svg');                  
  `}
   ${(props) => props.kind === 'tick' && css`
    background-image: url('/Site/images/icons/order-details/tick.svg');  
  `}
   ${(props) => props.kind === 'tick_black' && css`
    background-image: url('/Site/images/icons/order-details/tick_black.svg');
    width:10px;
    height:10px;
  `}
     ${(props) => props.kind === 'pending' && css`
    background-image: url('/Site/images/icons/order-details/pending.svg');  
  `}
   ${(props) => props.kind === 'ex' && css`
    background-image: url('/Site/images/icons/order-details/ex.svg');  
  `}
  ${(props) => props.kind === 'ex-gray' && css`
    background-image: url('/Site/images/icons/order-details/ex-gray.svg');  
  `}
   ${(props) => props.kind === 'arrow-right' && css`
    background-image: url('/Site/images/icons/order-details/arrow-right.svg');  
  `}
  ${(props) => props.kind === 'dots' && css`
    background-image: url('/Site/images/icons/order-details/dots.svg'); 
    &:active {
    background-image: url('/Site/images/icons/order-details/dots-selected.svg');
  }
  `}
   ${(props) => props.kind === 'download' && css`
    background-image: url('/Site/images/icons/order-details/download.svg'); 
     &:hover {
    background-image: url('/Site/images/icons/order-details/download-hover.svg');
  }
    &:active {
    background-image: url('/Site/images/icons/order-details/download-selected.svg');
  }
  `}
   ${(props) => props.kind === 'download-black' && css`
    background-image: url('/Site/images/icons/order-details/download-black.svg');
   `}
    ${(props) => props.kind === 'warning-colored' && css`
    background-image: url('/Site/images/icons/order-details/warning-colored.svg');
   `}
    ${(props) => props.kind === 'exclamation-icon' && css`
    background-image: url('/Site/images/icons/order-details/exclamation-icon.svg');
   `}
   ${(props) => props.kind === 'greater' && css`
    background-image: url('/Site/images/icons/order-details/greater.svg');
    width:20px;
    height:20px;
   `}
    ${(props) => props.kind === 'arrow-circle-left' && css`
    width:32px;
    height:32px;
    background-image: url('/Site/images/icons/order-details/arrow-circle-left.svg');
   `}
    ${(props) => props.kind === 'arrow-circle-right' && css`
    width:32px;
    height:32px;
    background-image: url('/Site/images/icons/order-details/arrow-circle-right.svg');
   `}
`;
const Icon = (props) => {
    return <StyledIcon id={props.id} kind={props.kind} />;
};

export default Icon;
